import React from "react";
import InputFactory from "../../../../../../components/InputFactory";

export default function CreateUserForm({
  schema,
  onChange,
  userInfo,
  fieldsToExlude,
  navigateBack,
  isEditing,
}) {
  return (
    <>
      <div className="d-flex flex-column row gap-5">
        {schema.map((section) => {
          return (
            <div key={section.name}>
              <h5 className="fw-bold text-primary">{section.name}</h5>
              {section.name ? (
                <hr
                  className="pb-2"
                  style={{ borderTop: "1px solid rgba(0, 0, 0, .2)" }}
                />
              ) : null}
              <div className="row">
                {Object.keys(section.fields).map((key, index) => {
                  if (fieldsToExlude.includes(key)) return null;
                  let { type, required, ...options } = section.fields[key];

                  if (key === "roles") {
                    type = "Pointer";
                  }

                  if (key === "password" && isEditing) {
                    required = false;
                  }

                  return (
                    <div
                      className={`${options.col} col-4 ${
                        index !== section.fields.length - 1 ? "mb-4" : ""
                      }`}
                      key={key}
                    >
                      <label
                        className="form-label fw-semibold"
                        style={{ fontSize: "0.875rem" }}
                      >
                        {options.label}
                        {required || options._required ? (
                          <span className="text-danger ms-1">*</span>
                        ) : null}
                      </label>
                      <InputFactory
                        field={key}
                        key={key}
                        object={userInfo}
                        type={type}
                        onChange={onChange}
                        required={required}
                        {...options}
                      />
                    </div>
                  );
                })}
                {section.name === "Login Information" && (
                  <div className="col-4" key="confirmPassword">
                    <label
                      className="form-label fw-semibold"
                      style={{ fontSize: "0.875rem" }}
                    >
                      Confirm Password
                      {!isEditing ? (
                        <span className="text-danger ms-1">*</span>
                      ) : null}
                    </label>
                    <InputFactory
                      field="confirmPassword"
                      key="confirmPassword"
                      object={userInfo}
                      type="Password"
                      placeholder="Minimum 8 characters"
                      onChange={onChange}
                      required={!isEditing}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <div className="d-flex gap-3 w-100 justify-content-center mt-5">
        <button
          type="button"
          style={{ width: "8rem" }}
          className="btn btn-light"
          onClick={navigateBack}
        >
          Cancel
        </button>
        <button style={{ width: "8rem" }} className="btn btn-primary">
          Save
        </button>
      </div>
    </>
  );
}
